import { getField, updateField } from 'vuex-map-fields';
export default {
  namespaced: true,

  state: () => ({
    category: null,
    categories: [],
    partner: null,
    filters: {
      file_type: null,
      category_id: 'all',
      language: null,
      co_branded: null,
      partner: null,
      is_ondemand: false,
      per_page: 10,
    },
  }),

  actions: {
    getCategories: async ({ commit, state }, { filters } = { filters: {} }) => {
      const url = state.partner
        ? `/partners/${state.partner}/categories`
        : `/partners/categories`;
      commit('setFilters', { filters });

      return await axios.get(url, { params: state.filters })
        .then(({ data }) => {
          commit('setCategories', { categories: data });
        });
    },
  },

  mutations: {
    setCategories: (state, { categories }) => state.categories = categories,
    setPartner: (state, { partner }) => state.partner = partner,
    setFilters: (state, { filters }) => state.filters = filters,
    updateField,
  },

  getters: {
    categories: ({ categories }) => categories,
    filters: ({ filters }) => filters,
    getField,
  },
};
